import React from 'react'
import { navlinks } from '../constants'
import { Link } from 'react-router-dom'
const MobileNav = ({ setOpen }: any) => {
    return (
        <div
            data-aos="fade-down" data-aos-duration="600"
            className='padding-container z-50 rounded-lg relative top-full left-0 bg-main-600 xs:w-full '>
            <ul className='xs:flex flex-col justify-center gap-5 md:hidden py-3 text-white '>
                {navlinks.map((navlink, index) => (
                    <li key={index} >
                        <Link to={navlink.href} onClick={()=>setOpen(false)}>
                            <p className=' transition-all hover:text-black font-bold  '>{navlink.name}</p>
                        </Link>
                    </li>
                ))
                }
                
            </ul>
        </div>
    )
}

export default MobileNav
